import React from 'react'
import styled from '@emotion/styled'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { colors, font, radius, spacing } from '@mobi/component-library/Foundations'

type Props = {
  ownerAccountDisplayName: string
  isMySharedBet: boolean
}

export const CashedOutBanner: React.FC<Props> = ({ ownerAccountDisplayName, isMySharedBet }) => {
  const displayText = isMySharedBet
    ? 'You Cashed Out this bet'
    : `${ownerAccountDisplayName} Cashed Out this bet`

  return (
    <BannerStyled>
      <Icon name='CustomCashedOut' size='1.6rem' color={colors.mariner[500]} />
      <span>{displayText}</span>
    </BannerStyled>
  )
}

// ======
// Styles
// ======

const BannerStyled = styled.div({
  position: 'relative',
  zIndex: 0,
  marginTop: '-2rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: spacing.smx2,
  backgroundColor: colors.mariner[50],
  borderRadius: `0 0 ${radius.lgx1} ${radius.lgx1}`,
  paddingTop: spacing.big,
  paddingBottom: spacing.sm,
  fontFamily: font.family.primary,
  fontSize: font.size.md.fontSize,
  lineHeight: font.size.md.lineHeight,
  fontWeight: font.weight.regular,
  color: colors.mariner[500],
  textAlign: 'center',
})
